 <p-table #dt1 styleClass="p-datatable-xs p-datatable-striped sticky-header p-inner-table-auto head-top"
         dataKey="Id"
         [selectionMode]="selectionMode"
         [metaKeySelection]="true"
         [stateStorage]="appConfig.primeNgStateStorage"
         [autoLayout]="false"
         [value]="filteredData$ | async"
         [lazy]="true"
         [lazyLoadOnInit]="true"
         [paginator]="true"
         [sortField]="tableSortField"
         [sortOrder]="tableSortOrder"
         [rows]="filter.Page.Size"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [showCurrentPageReport]="true"
         [totalRecords]="filter.Page.Total"
         [filters]="tableFilters"
         [stateKey]="stateKey"
         [first]="filter.Page.Number * filter.Page.Size"
         [(selection)]="selectedItem"
         (onRowSelect)="onRowSelect()"
         (onLazyLoad)="onLazyLoad($event)"
         (onStateRestore)="onStateRestore($event)"
         currentPageReportTemplate="{first} to {last} of {totalRecords}">
  <ng-template pTemplate="header" let-columns>
    <ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-item'">
      <tr class="sticky-top-2">
        <th style="width: 4rem" *ngIf="selectionMode == 'multiple'">
          <p-tableHeaderCheckbox (click)="onRowSelect()"></p-tableHeaderCheckbox>
        </th>
        <th pSortableColumn="Code">
          <div class="d-flex">
            {{t('Code')}}
            <p-sortIcon field="Code" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter type="text" field="Code" display="menu" matchMode="equals" #codeFilter></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="Name">
          <div class="d-flex">
            {{t('Name')}}
            <p-sortIcon field="Name" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter type="text" field="Name" display="menu" matchMode="equals" #nameFilter></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="TypeClv" *ngIf="selectableColumns.TypeClv">
          <div class="d-flex">
            {{t('Type')}}
            <p-sortIcon field="TypeClv" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="TypeClv" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" name="typeFilter"
                           [items]="classificatorValuesQuery.itemTypes$ | async" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                           [ngModel]="value" (ngModelChange)="filter($event)">
                </ng-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="ItemGroupId" class="wx-256">
          <div class="d-flex">
            {{t('Item Group')}}
            <p-sortIcon field="ItemGroupId" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="contains" display="menu" field="ItemGroupId" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true"
                            [maxConstraints]="10" #itemGroupFilter>
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <div class="mx-wx-256">
                  <ng-select class="select-sm form-control" [selectOnTab]="true" name="itemGroupFilter" [multiple]="true"
                             [groupBy]="groupByFn" [groupValue]="groupValueFn" [items]="itemGroupsQuery.itemGroupsByDataset$ | async" [virtualScroll]="true" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                             [ngModel]="value" (ngModelChange)="filter($event)">
                    <ng-template ng-label-tmp let-item="item">
                      <app-item-group-display-name [itemGroup]="item"/>
                    </ng-template>
                    <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                      <app-item-group-display-name [itemGroup]="item"/>
                    </ng-template>
                  </ng-select>
                </div>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            {{t('Datasets')}}
            <p-columnFilter class="ms-auto" matchMode="contains" display="menu" field="ToItemGroupId" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10" [showMenu]="!defaultFilter['ToItemGroupId']" #datasetFilter>
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-select class="select-sm form-control" [selectOnTab]="true" name="ToItemGroupIdFilter" [multiple]="true" #toItemGroupSelect
                           [groupBy]="groupByFn" [groupValue]="groupValueFn" [items]="itemGroupsQuery.itemGroupsByDataset$ | async" [virtualScroll]="true" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                           [selectableGroup]="false"
                           [selectableGroupAsModel]="false"
                           [ngModel]="value" (ngModelChange)="filter($event)">
                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" type="checkbox" class="me-1" (change)="selectFilteredChildren(toItemGroupSelect, item)"/>
                    <app-item-group-display-name [itemGroup]="item"/>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <app-item-group-display-name [itemGroup]="item"/>
                  </ng-template>
                </ng-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="InventoryUnitId" class="wx-128" *ngIf="selectableColumns.InventoryUnit">
          <div class="d-flex">
            {{t('Inventory Unit')}}
            <p-sortIcon field="InventoryUnitId" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="InventoryUnitId" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" name="inventoryUnitFilter"
                           [items]="unitsQuery.getAll$ | async" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                           [ngModel]="value" (ngModelChange)="filter($event)">
                </ng-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="AssignedTo" class="wx-128" *ngIf="selectableColumns.AssignedTo">
          <div class="d-flex">
            {{t('Assigned to')}}
            <p-sortIcon field="AssignedTo" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="AssignedTo" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" name="itemGroupFilter"
                           [items]="usersQuery.getAll$ | async | orderBy : 'Fullname'" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                           [ngModel]="value" (ngModelChange)="filter($event)">
                </ng-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="StatusClv" class="wx-128" *ngIf="selectableColumns.StatusClv">
          <div class="d-flex">
            {{t('Status')}}
            <p-sortIcon field="StatusClv" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="StatusClv" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-container *ngIf="statusCls$ | async as cls">
                  <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" name="statusFilter"
                             [items]="classificatorValuesQuery.getAll$ | async | where: 'ClassificatorId': cls" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                             [ngModel]="value" (ngModelChange)="filter($event)">
                  </ng-select>
                </ng-container>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="ModifiedDate" class="min-wx-128" *ngIf="selectableColumns.ModifiedDate">
          <div class="d-flex">
            {{t('Modified')}}
            <p-sortIcon field="ModifiedDate" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="dateAfter" type="date" field="ModifiedDate" display="menu">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <input id="filterByModifiedDate" name="filterByModifiedDate" class="form-control form-control-sm" ngbDatepicker #dFrom="ngbDatepicker" (click)="dFrom.toggle()" type="search" [ngModel]="value"
                       (ngModelChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="ModifiedBy" class="min-wx-128" *ngIf="selectableColumns.ModifiedBy">
          <div class="d-flex">
            {{t('Modified by')}}
            <p-sortIcon field="ModifiedBy" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="ModifiedBy" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" name="modifiedByFilter"
                           [items]="usersQuery.getAll$ | async" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                           [ngModel]="value" (ngModelChange)="filter($event)">
                </ng-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="InventoryMin" class="min-wx-128" *ngIf="selectableColumns.InventoryMin">
          <div class="d-flex">
            {{t('Inventory min')}}
            <p-sortIcon field="InventoryMin" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="InventoryMin" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="InventoryMax" class="min-wx-128" *ngIf="selectableColumns.InventoryMax">
          <div class="d-flex">
            {{t('Inventory max')}}
            <p-sortIcon field="InventoryMax" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="InventoryMax" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="PurchaseLotSizeMin" class="min-wx-128" *ngIf="selectableColumns.PurchaseLotSizeMin">
          <div class="d-flex">
            {{t('Purchase lot size min')}}
            <p-sortIcon field="PurchaseLotSizeMin" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="PurchaseLotSizeMin" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="PurchaseLotSizeMax" class="min-wx-128" *ngIf="selectableColumns.PurchaseLotSizeMax">
          <div class="d-flex">
            {{t('Purchase lot size max')}}
            <p-sortIcon field="PurchaseLotSizeMax" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="PurchaseLotSizeMax" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="ProductionLotSizeMin" class="min-wx-128" *ngIf="selectableColumns.ProductionLotSizeMin">
          <div class="d-flex">
            {{t('Production lot size min')}}
            <p-sortIcon field="ProductionLotSizeMin" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="ProductionLotSizeMin" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="ProductionLotSizeMax" class="min-wx-128" *ngIf="selectableColumns.ProductionLotSizeMax">
          <div class="d-flex">
            {{t('Production lot size max')}}
            <p-sortIcon field="ProductionLotSizeMax" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="ProductionLotSizeMax" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="OwnerClv" class="wx-128" *ngIf="selectableColumns.OwnerClv">
          <div class="d-flex">
            {{t('Owner')}}
            <p-sortIcon field="OwnerClv" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="OwnerClv" [matchModeOptions]="choiceMatchModeOptions" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <ng-select class="select-sm form-control dropdown-auto-width" [selectOnTab]="true" name="statusFilter"
                           [items]="classificatorValuesQuery.itemOwners$ | async" bindValue="Id" bindLabel="DisplayName" [appendTo]="null"
                           [ngModel]="value" (ngModelChange)="filter($event)"></ng-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="OperationSplitSizeMax" class="min-wx-128" *ngIf="selectableColumns.OperationSplitSizeMax">
          <div class="d-flex">
            {{t('Operation split size max')}}
            <p-sortIcon field="OperationSplitSizeMax" class="ms-auto align-self-center"></p-sortIcon>
            <p-columnFilter matchMode="equals" display="menu" field="OperationSplitSizeMax" [matchModeOptions]="numericMatchModeOptions" [type]="'numeric'" [showAddButton]="true" [showOperator]="true" [maxConstraints]="10">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback" let-constraint="filterConstraint">
                <input class="form-control form-control" [mesNumberInput]="value" (onChange)="filter($event)">
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="min-wx-96" *ngFor="let spec of filter.Data.SelectedSpecs">
          <div class="d-flex" *ngIf="(propertiesQuery.selectEntity(spec) | async) as property">
            {{property | displayName}}
          </div>
        </th>
        <th>
          <div class="dropdown ms-auto wx-32" #menu="ngbDropdown" ngbDropdown [autoClose]="false" [placement]="['bottom-right', 'bottom-left']" (openChange)="onTableDropdownOpen($event)">
            <button type="button" class="p-column-filter-menu-button p-link dropdown-toggle-without-arrow" [class.p-column-filter-menu-button-active]="hasFilters" ngbDropdownToggle role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <span class="pi pi-filter-icon pi-filter"></span>
            </button>
            <div ngbDropdownMenu>
              <button type="button" class="dropdown-item" (click)="clearState(); menu.close();">{{t('Clear Sort/Filter')}}</button>
              <app-saved-filter-menu-item [savedFilterPropertyId]="itemListPropertyId" [stateKey]="stateKey" (selected)="loadSavedState($event)"></app-saved-filter-menu-item>
              <button *ngIf="hasBulkEdit" type="button" class="dropdown-item" [class.active]="showBulkEdit" (click)="showBulkEdit = !showBulkEdit; menu.close();">{{t('Show bulk edit row')}}</button>
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header">{{t('Columns')}}</h6>
              <div ngbDropdown #specMenu="ngbDropdown" class="dropdown-item" container="body" placement="left-top" [autoClose]="'outside'">
                <button class="btn btn-link p-0" ngbDropdownToggle data-toggle="dropdown">{{t('Specs')}}</button>
                <div ngbDropdownMenu>
                  <app-spec-search-menu-item [relevantSpecs]="allSpecs" [tableDropdownClosed]="tableDropdownClosed" [filterData]="filter.Data" (selectionChange)="toggleSpecSelection($event, filter)"
                                             (showOnlyRelevantSpecsChange)="tryLazyLoad(); toggleSpecFilterSelection(filter)"
                                             (includeInheritedValuesChange)="tryLazyLoad(); toggleSpecFilterSelection(filter)"
                                             (includeSpecConstraintsValuesChange)="tryLazyLoad(); toggleSpecFilterSelection(filter)"/>
                </div>
              </div>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.TypeClv = !selectableColumns.TypeClv; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.TypeClv">
                </svg>
                {{t('Type')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.InventoryUnit = !selectableColumns.InventoryUnit; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.InventoryUnit">
                </svg>
                {{t('Inventory Unit')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.AssignedTo = !selectableColumns.AssignedTo; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.AssignedTo">
                </svg>
                {{t('Assigned To')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.StatusClv = !selectableColumns.StatusClv; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.StatusClv">
                </svg>
                {{t('Status')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.ModifiedDate = !selectableColumns.ModifiedDate; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.ModifiedDate">
                </svg>
                {{t('Modified')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.ModifiedBy = !selectableColumns.ModifiedBy; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.ModifiedBy">
                </svg>
                {{t('Modified by')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.InventoryMin = !selectableColumns.InventoryMin; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.InventoryMin">
                </svg>
                {{t('Inventory min')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.InventoryMax = !selectableColumns.InventoryMax; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.InventoryMax">
                </svg>
                {{t('Inventory max')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.PurchaseLotSizeMin = !selectableColumns.PurchaseLotSizeMin; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.PurchaseLotSizeMin">
                </svg>
                {{t('Purchase lot size min')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.PurchaseLotSizeMax = !selectableColumns.PurchaseLotSizeMax; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.PurchaseLotSizeMax">
                </svg>
                {{t('Purchase lot size max')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.ProductionLotSizeMin = !selectableColumns.ProductionLotSizeMin; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.ProductionLotSizeMin">
                </svg>
                {{t('Production lot size min')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.ProductionLotSizeMax = !selectableColumns.ProductionLotSizeMax; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.ProductionLotSizeMax">
                </svg>
                {{t('Production lot size max')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.OwnerClv = !selectableColumns.OwnerClv; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.OwnerClv">
                </svg>
                {{t('Owner')}}
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="selectableColumns.OperationSplitSizeMax = !selectableColumns.OperationSplitSizeMax; updateTableColumnState()">
                <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check" *ngIf="selectableColumns.ProductionLotSizeMax">
                </svg>
                {{t('Operation split size max')}}
              </button>
            </div>
          </div>
          <button type="button" *ngIf="updateMarker$ | async" class="p-column-filter-menu-button p-column-filter-menu-button-active" role="button" [ngbTooltip]="t('Item cache updated - reload to see possible changes')"
                  (click)="tryLazyLoad()">
            <span class="pi pi-refresh"></span>
          </button>
        </th>
      </tr>
      <tr *ngIf="filter.AdvancedFilter">
        <th>
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="codeFilter">
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th>
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="nameFilter">
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.TypeClv">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'TypeClv'">
              <ng-template #valueTemplate let-value="value">
                {{classificatorValuesQuery.selectEntity(value) | async | displayName}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th>
          <div class="d-flex justify-content-between flex-wrap position-relative">
            <app-column-filter-field-constraints-view class="col" [filter]="itemGroupFilter">
              <ng-template #valueTemplate let-value="value">
                <app-item-group-display-name [itemGroupId]="value" [codeOnly]="true"/>
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th>
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="datasetFilter">
              <ng-template #valueTemplate let-value="value">
                <app-item-group-display-name [itemGroupId]="value"/>
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.InventoryUnit">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'InventoryUnit'">
              <ng-template #valueTemplate let-value="value">
                {{unitsQuery.selectEntity(value) | async | displayName}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.AssignedTo">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'AssignedTo'">
              <ng-template #valueTemplate let-value="value">
                {{(usersQuery.selectEntity(value) | async)?.DisplayName}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.StatusClv">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'StatusClv'">
              <ng-template #valueTemplate let-value="value">
                {{classificatorValuesQuery.selectEntity(value) | async | displayName}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.ModifiedDate">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'ModifiedDate'">
              <ng-template #valueTemplate let-value="value">
                {{value | date : 'shortDate'}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.ModifiedBy">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'ModifiedBy'">
              <ng-template #valueTemplate let-value="value">
                {{(usersQuery.selectEntity(value) | async)?.DisplayName}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngIf="selectableColumns.InventoryMin">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'InventoryMin'"/>
        </th>
        <th *ngIf="selectableColumns.InventoryMax">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'InventoryMax'"/>
        </th>
        <th *ngIf="selectableColumns.PurchaseLotSizeMin">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'PurchaseLotSizeMin'"/>
        </th>
        <th *ngIf="selectableColumns.PurchaseLotSizeMax">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'PurchaseLotSizeMax'"/>
        </th>
        <th *ngIf="selectableColumns.ProductionLotSizeMin">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'ProductionLotSizeMin'"/>
        </th>
        <th *ngIf="selectableColumns.ProductionLotSizeMax">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'ProductionLotSizeMax'"/>
        </th>
        <th *ngIf="selectableColumns.OperationSplitSizeMax">
          <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'OperationSplitSizeMax'"/>
        </th>
        <th *ngIf="selectableColumns.OwnerClv">
          <div class="d-flex justify-content-between flex-wrap">
            <app-column-filter-field-constraints-view class="col" [filter]="columnFilterComponents | find: 'field': 'OwnerClv'">
              <ng-template #valueTemplate let-value="value">
                {{classificatorValuesQuery.selectEntity(value) | async | displayName}}
              </ng-template>
            </app-column-filter-field-constraints-view>
          </div>
        </th>
        <th *ngFor="let spec of filter.Data.SelectedSpecs" app-spec-column-filter [allSpecs]="allSpecs" [spec]="spec" class="min-wx-96"></th>
        <th></th>
      </tr>
      <tr class="bg-red-100" *ngIf="hasBulkEdit && showBulkEdit">
        <th colspan="10">
          <span class="text-muted">{{t('Tip: filter by specs to bulk edit the values of these specs in items that are in this list')}}</span>
        </th>
        <th *ngFor="let spec of filter.Data.SelectedSpecs">
          <ng-container *ngLet="bulkEditSpecs | filterBy: ['PropertyId'] : spec as bulkEditSpecsByProperty">
            <ng-container *ngIf="bulkEditSpecsByProperty.length; else addbulkEditSpecTmpl">
              <div *ngFor="let bulkEditSpec of bulkEditSpecsByProperty" class="bg-teal-200 border-white b-1 rounded-3 m-n1 p-2">
                <form>
                  <web-spec-value [spec]="bulkEditSpec"></web-spec-value>
                  <div class="d-flex mt-1">
                    <ng-select class="select-sm form-control" [items]="languagesQuery.getAll$ | async" [placeholder]="t('Language')" [(ngModel)]="bulkEditSpec.LanguageId" bindLabel="DisplayName"
                               name="LanguageId-{{bulkEditSpec.Id}}" bindValue="Id"></ng-select>
                    <button type="button" class="btn btn-sm btn-outline-primary mx-1 w-25 text-nowrap" [title]="t('Remove')" (click)="removeBulkEditSpec(bulkEditSpec)">
                      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#x-mark"></svg>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary w-25 text-nowrap" [title]="t('Add')" (click)="addBulkEditSpec(spec)">
                      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                    </button>
                  </div>
                </form>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #addbulkEditSpecTmpl>
            <button type="button" class="btn btn-sm btn-outline-primary text-nowrap" (click)="addBulkEditSpec(spec)">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
              {{t('Set rule')}}
            </button>
          </ng-template>
        </th>
        <th class="text-end">
          <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="!bulkEditSpecs.length" (click)="applyBulkEdit()">
            {{t('Apply')}}
          </button>
        </th>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="body" let-row let-rowIndex>
    <ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-item'">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex">
        <td>
          <app-item-display-name [itemId]="row.Id" [codeOnly]="true"/>
        </td>
        <td class="text-wrap text-break">
          <ng-container *ngIf="!rowSelectEnabled && urlForEdit; else rowSelectMode">
            <a [routerLink]="[urlForEdit, row.Id]" [queryParams]="{ tab: 'general' }">{{row.Name}}</a>
          </ng-container>
          <ng-template #rowSelectMode>
            {{row.Name}}
          </ng-template>
        </td>
        <td *ngIf="selectableColumns.TypeClv">
          {{classificatorValuesQuery.selectEntity(row.TypeClv) | async | displayName}}
        </td>
        <td>
          <a class="badge bg-primary me-1 mt-1 px-1 text-wrap text-break text-start text-white text-decoration-none" [routerLink]="['/manufacturing/item-template/edit', row.ItemGroupId]">
            <app-item-group-display-name [itemGroupId]="row.ItemGroupId"></app-item-group-display-name>
          </a>
        </td>
        <td>
          <ng-container *ngLet="filter.Data.ToItemGroupId | pluck: 'value' | flatten | intersection: row.Datasets as filtered">
            <ng-container *ngFor="let dataset of row.Datasets?.slice(0, 10)">
              <a class="badge bg-primary me-1 mt-1 px-1 text-wrap text-break text-start text-white text-decoration-none" [class.bg-success]="filtered?.includes(dataset)" [routerLink]="['/manufacturing/item-template/edit', dataset]">
                <app-item-group-display-name [itemGroupId]="dataset"></app-item-group-display-name>
              </a>
            </ng-container>
            <span *ngIf="row.Datasets?.length > 10" class="badge bg-gray-300 me-1 px-1 text-light">+{{row.Datasets?.length - 10}}</span>
          </ng-container>

        </td>
        <td *ngIf="selectableColumns.InventoryUnit">
          {{(unitsQuery.selectEntity(row.InventoryUnitId) | async)?.Code}}
        </td>
        <td *ngIf="selectableColumns.AssignedTo">
          {{(usersQuery.selectEntity(row.AssignedTo) | async)?.DisplayName}}
        </td>
        <td *ngIf="selectableColumns.StatusClv">
          {{classificatorValuesQuery.selectEntity(row.StatusClv) | async | displayName}}
        </td>
        <td *ngIf="selectableColumns.ModifiedDate">
          {{row.ModifiedDate | date: 'short'}}
        </td>
        <td *ngIf="selectableColumns.ModifiedBy">
          {{(usersQuery.selectEntity(row.ModifiedBy) | async)?.DisplayName}}
        </td>
        <td *ngIf="selectableColumns.InventoryMin">
          {{row.InventoryMin}}
        </td>
        <td *ngIf="selectableColumns.InventoryMax">
          {{row.InventoryMax}}
        </td>
        <td *ngIf="selectableColumns.PurchaseLotSizeMin">
          {{row.PurchaseLotSizeMin}}
        </td>
        <td *ngIf="selectableColumns.PurchaseLotSizeMax">
          {{row.PurchaseLotSizeMax}}
        </td>
        <td *ngIf="selectableColumns.ProductionLotSizeMin">
          {{row.ProductionLotSizeMin}}
        </td>
        <td *ngIf="selectableColumns.ProductionLotSizeMax">
          {{row.ProductionLotSizeMax}}
        </td>
        <td *ngIf="selectableColumns.OwnerClv">
          {{classificatorValuesQuery.selectEntity(row.OwnerClv) | async | displayName}}
        </td>
        <td *ngIf="selectableColumns.OperationSplitSizeMax">
          {{row.OperationSplitSizeMax}}
        </td>
        <td *ngFor="let spec of filter.Data.SelectedSpecs">
          <ng-container *ngIf="row.Specs[spec]">{{row.Specs[spec][0]?.Value}}</ng-container>
          <div *ngFor="let groupByValue of row.Specs[spec] | tail: 1 | groupByValues: 'Value'">
            <span class="fw-light fst-italic" *ngFor="let line of groupByValue; let last = last">
              {{(languagesQuery.selectEntity(line.Key) | async)?.Code}}{{last ? ':' : ', '}}
            </span>
            {{groupByValue[0]?.Value}}
          </div>
        </td>
        <td class="text-end" [width]="100" (click)="$event.stopPropagation()" style="cursor: default">
          <div class="d-flex flex-nowrap">
            <ng-container
              [ngTemplateOutlet]="buttonsTemplate"
              [ngTemplateOutletContext]="{ row: row, filter: filter }">
            </ng-container>
            <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="showGraph(row)" [title]="t('Graph')">
              <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#fork'">
              </svg>
            </button>
            <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="open(row)" [title]="t('Open')">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
            </button>
          </div>
        </td>
      </tr>
    </ng-container>
  </ng-template>
</p-table>
